module.exports = __webpack_public_path__ + "static/media/mindef-back.5a8d1f08.png";